import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';
import useDictionary from 'lib/sitecore/use-dictionary';
import { useIsNRC } from 'lib/util/site-configuration';

export const FileHit = ({ hit }: HitProps) => {
  const isNetworkSite = useIsNRC();
  const dict = useDictionary();

  return (
    <div>
      <div className={classnames('mb-2', 'searchTypeHead')}>
        {isNetworkSite ? (
          <>
            <span className="searchType">File</span>
            <span
              className={classnames(
                'border-r',
                'h-3',
                'mx-3',
                'inline-block',
                'border-gray-midGray'
              )}
            />
          </>
        ) : (
          <>File &emsp;| &emsp;</>
        )}
        {dict[hit.fileTypeId]}
      </div>
      <HitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" />
      </HitHeadline>
      <Snippet
        hit={hit}
        attribute="body"
        className={classnames('line-clamp-4', 'md:line-clamp-2')}
      />
    </div>
  );
};
